import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter);

//push
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
	return VueRouterPush.call(this, to).catch(err => err)
}

const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(to) {
	return VueRouterReplace.call(this, to).catch(err => err)
}

// 前台用户系统路由
const foreRouter = [{
	path: '/home',
	name: 'Home',
	component: () => import('@/views/foreground/home.vue')
}, {   // 检索页面
	path: '/searchList',
	name: 'SearchList',
	component: () => import('@/views/foreground/searchList.vue')
}, {
	path: '/virusDetail/:id',
	name: 'VirusDetail',
	component: () => import('@/views/foreground/virusDetail.vue')
}, {
	path: '/queryHistory',
	name: 'QueryHistory',
	component: () => import('@/views/foreground/sequenceRetrieval/queryHistory.vue')
}, {
	path: '/sequenceRetrievalDetail',
	name: 'SequenceRetrievalDetail',
	component: () => import('@/views/foreground/sequenceRetrieval/sequenceRetrievalDetail.vue')
}, {
	path: '/advancedSearch',
	name: 'AdvancedSearch',
	component: () => import('@/views/foreground/sequenceRetrieval/advancedSearch.vue')
}, {
	path: '/sequenceSearch',
	name: 'SequenceSearch',
	component: () => import('@/views/foreground/sequenceRetrieval/sequenceSearch.vue')
}, {
	path: '/structureSearch',
	name: 'StructureSearch',
	component: () => import('@/views/foreground/sequenceRetrieval/structureSearch.vue')
}, {
	path: '/register',
	name: 'Register',
	component: () => import('@/views/foreground/user/register.vue'),
	meta: {
		notPage: true
	}
}, {
	path: '/login',
	name: 'Login',
	component: () => import('@/views/foreground/user/login.vue'),
	meta: {
		notPage: true
	}
}, {
	path: '/mailverification',
	name: 'Mailverification',
	component: () => import('@/views/foreground/user/mailverification.vue')
}, {
	path: '/changePassword',
	name: 'ChangePassword',
	component: () => import('@/views/foreground/user/changePassword.vue')
}, {
	path: '/forget',
	name: 'Forget',
	component: () => import('@/views/foreground/user/forget.vue')
}, {
	path: '/structureAlignment',
	name: 'StructureAlignment',
	component: () => import('@/views/foreground/Structure/Submit.vue')
}]

import {
	menus
} from "@/constant/data.js"
// 后台管理路由
const manageRouter = [
	...menus,
]

const router = new VueRouter({
	routes: [{
		path: '/',
		redirect: '/index'
	}, {
		path: '/index',
		name: 'Index',
		redirect: '/home',
		component: () => import('@/views/index.vue'),
		children: [
			// 前台用户系统
			{
				path: '/fore',
				name: 'Fore',
				redirect: '/home',
				component: () => import('@/views/foreground/index.vue'),
				children: [
					...foreRouter
				]
			},
			// 后台管理
			{
				path: '/manage',
				name: 'Manage',
				component: () => import('@/views/manage/index.vue'),
				redirect: '/manageHome',
				children: [
					{
						path: '/manageLogin',
						name: 'ManageLogin',
						component: () => import('@/views/manage/login.vue')
					},
					{
						path: '/manageHome',
						name: 'ManageHome',
						redirect: '/userManage',
						component: () => import('@/views/manage/pages/home.vue'),
						children: [
							...manageRouter
						]
					}
				]
			}
		]
	}, {
		path: '/404',
		component: () => import('@/views/404.vue')
	}, {
		path: '*',
		redirect: '/404'
	}]
})

// 路由跳转前
router.beforeEach((to, from, next) => {
	to.meta.title && (document.title = to.meta.title);

	// 后台管理页面需要登录（manageLogin 除外）
	if (to.path.startsWith('/manage') && to.path !== '/manageLogin') {
		// 依赖后端 session 判断，通过请求 getloginstatus 确认
		// 前端仅做基础保护，后端接口也有 isManage 拦截
		next()
	} else if (to.meta.notPage) {
		next('/home')
	} else {
		next()
	}
})

// 路由跳转后
router.afterEach((to, from) => {
	window.scrollTo(0, 0) // 每次路由改变滚动条都回到顶部
})

export default router
